export const isNotificationOpen = (notificationsState, notificationId) => {
  const notificationData = notificationsState.notifications.find(
    notification => notification.id === notificationId
  );

  if (
    !notificationData.permanent &&
    notificationData.hasOwnProperty('duration') &&
    notificationData.duration &&
    notificationData.sentAt <= new Date().getTime() - notificationData.duration
  ) {
    return false;
  } else {
    return !notificationsState.closedNotifications.includes(notificationId);
  }
};

const NOTIFICATION_SPACING = 38;
const NOTIFICATION_TITLE_HEIGHT = 45;
const NOTIFICATION_TITLE_DESCRIPTION_HEIGHT = 71;

export const getNotificationHeight = ({ title, message }) => {
  if (title && message) {
    return NOTIFICATION_TITLE_DESCRIPTION_HEIGHT + NOTIFICATION_SPACING;
  } else {
    return NOTIFICATION_TITLE_HEIGHT + NOTIFICATION_SPACING;
  }
};
